/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/Create
 * @desc Create Action for experiment workflow
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import type { EntityActionCreateContainerProps } from 'labstep-web/components/Entity/Action/Create/types';
import ExperimentWorkflowActionCreateWithFolder from 'labstep-web/components/ExperimentWorkflow/Action/CreateWithFolder';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import { addActionComponentPropsToDefault } from 'labstep-web/core/Action/Component/utils';
import type { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';
import type { ExperimentWorkflowActionCreateProps } from './types';

export const ExperimentWorkflowActionCreate: React.FC<
  ExperimentWorkflowActionCreateProps
> = ({
  protocol,
  body,
  actionComponentProps: extraActionComponentProps,
  activeGroup,
}) => {
  const redirectRoute: EntityActionCreateContainerProps['redirectRoute'] =
    ({ response }) =>
      ({
        to: protocol ? 'experiment_show' : 'experiment_workflow_show',
        params: {
          id: protocol
            ? (
                response.entities.experiment_workflow[
                  response.result as number
                ] as ExperimentWorkflow
              ).experiment_ids[1]
            : response.result,
        },
      }) as const;

  let actionComponentProps = {
    dataCy: 'components/ExperimentWorkflow/Action/Create',
    type: 'button',
    elementProps: {
      ...(protocol && { color: 'green' }),
      primary: !protocol,
    },
    ...(protocol && {
      text: 'Run',
      icon: 'play',
      showIcon: true,
    }),
  } as ActionComponentProps;

  actionComponentProps = addActionComponentPropsToDefault(
    actionComponentProps,
    extraActionComponentProps,
  );

  const folderId = body?.folder_id;
  if (
    !protocol &&
    !folderId &&
    activeGroup &&
    !activeGroup.is_unsorted_folder_experiment_workflow_enabled &&
    !activeGroup.default_experiment_workflow_folder
  ) {
    return (
      <ExperimentWorkflowActionCreateWithFolder
        actionComponentProps={actionComponentProps}
      />
    );
  }

  return (
    <EntityActionCreate
      entityName="experiment_workflow"
      redirectRoute={redirectRoute}
      actionComponentProps={actionComponentProps}
      body={protocol ? { protocol_id: protocol.id, ...body } : body}
    />
  );
};

export default withActiveGroup(ExperimentWorkflowActionCreate);
